import { Button, ButtonColorVariant, ButtonSize, ButtonVariant } from "@/components/ui/button";
import { DateRangePickerInput } from "@/components/ui/date-range-picker-input";
import { TrashIcon } from "lucide-react";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { BaseFilterProps, Filter, FilterData } from "../_types";

export class SapExportPeriodFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "exportPeriod";
  readonly labelSingular = "aceSapExportIssues:ExportPeriod";
  readonly labelPlural = "aceSapExportIssues:ExportPeriod";
  readonly placeholder = "aceSapExportIssues:ExportPeriod";
  readonly searchPlaceholder = "";
  readonly emptyText = "";
  body = {};
  parameters = {};

  getData(): FilterData {
    return { options: [], isLoading: false, error: null };
  }

  render(props: BaseFilterProps): ReactElement {
    return <ExportPeriodFilterComponent {...props} />;
  }
}

function ExportPeriodFilterComponent({ selectedValues, onSelectionChange, disabled }: BaseFilterProps): ReactElement {
  const { t } = useTranslation(["common", "aceSapExportIssues"]);
  const from = selectedValues[0] ?? "";
  const to = selectedValues[1] ?? "";
  const hasValues = from !== "" || to !== "";

  function handleFromChange(value: string): void {
    onSelectionChange(value === "" && to === "" ? [] : [value, to]);
  }

  function handleToChange(value: string): void {
    onSelectionChange(from === "" && value === "" ? [] : [from, value]);
  }

  return (
    <div className="flex flex-col">
      <span className="text-sm font-medium">{t("aceSapExportIssues:ExportPeriod")}</span>
      <div className="flex items-center gap-2">
        <DateRangePickerInput
          from={from}
          to={to}
          onFromChange={handleFromChange}
          onToChange={handleToChange}
          disabled={disabled}
          className="min-w-0 flex-1"
        />
        <Button
          variant={ButtonVariant.Outlined}
          colorVariant={ButtonColorVariant.Secondary}
          size={ButtonSize.Icon}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onSelectionChange([]);
          }}
          className="shrink-0"
          disabled={!hasValues || disabled}
          aria-label={t("common:Remove")}
        >
          <TrashIcon className="size-4" />
        </Button>
      </div>
    </div>
  );
}
